module.exports = "../../static/img/more.7fc587b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.png
// module id = uty8
// module chunks = 1